var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1888_1104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1888_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3313 31.6688C24.596 32.404 23.404 32.404 22.6688 31.6688L10.4142 19.4142C9.63317 18.6332 9.63317 17.3668 10.4142 16.5858L22.6687 4.33125C23.404 3.59602 24.596 3.59602 25.3313 4.33125V4.33125C26.0665 5.06648 26.0665 6.25852 25.3313 6.99375L15.7392 16.5858C14.9582 17.3668 14.9582 18.6332 15.7392 19.4142L25.3313 29.0063C26.0665 29.7415 26.0665 30.9335 25.3313 31.6688V31.6688Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeBack);
export default __webpack_public_path__ + "static/media/mode-back.b7de3404efc48361687128dbae14fd5c.svg";
export { ForwardRef as ReactComponent };